import { render, staticRenderFns } from "./popupMenu.vue?vue&type=template&id=520b8cda&"
import script from "./popupMenu.vue?vue&type=script&lang=js&"
export * from "./popupMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports